(function() {
  // Quick add form submission
  document.querySelectorAll('.img-products__product-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.img-products__product-atc');
      var variantId = form.querySelector('input[name="id"]').value;

      if (btn) {
        btn.classList.add('btn-loading');
        btn.disabled = true;
      }

      if (window.addToCart) {
        window.addToCart(variantId, 1).finally(function() {
          if (btn) {
            btn.classList.remove('btn-loading');
            btn.disabled = false;
          }
        });
      }
    });
  });
})();
